// Payment amount strategies
export const CURRENT_BALANCE = 'CURRENT_BALANCE'
export const STATEMENT_BALANCE = 'STATEMENT_BALANCE'
export const MINIMUM_PAYMENT = 'MINIMUM_PAYMENT'
export const OTHER = 'FIXED_AMOUNT'

export const amountOptionLabel = {
  [CURRENT_BALANCE]: 'Current balance',
  [STATEMENT_BALANCE]: 'Statement balance',
  [MINIMUM_PAYMENT]: 'Minimum payment due',
  [OTHER]: 'Other amount',
  [null]: 'Other amount',
}

export const FORM_SUBMIT_ATTEMPTED_STATUS = 'Submit Attempted'

export const AUTOPAY_CREATED = 'AUTOPAY_CREATED'
export const STATEMENT_NOT_READY = 'STATEMENT_NOT_READY'
export const AUTOPAY_NOT_FOUND = 'AUTOPAY_NOT_FOUND'
export const AUTOPAY_RETRIEVED = 'AUTOPAY_RETRIEVED'
export const AUTOPAY_DELETED = 'AUTOPAY_DELETED'

export const RECURRING_PAYMENT_NOT_FOUND = 'Recurring payment not found for user'
